module.exports = __webpack_public_path__ + "static/img/fl23_1.9f88fce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fl20210204/fl23_1.png
// module id = KfGU
// module chunks = 0